import { render, staticRenderFns } from "./CancelOrderModal.vue?vue&type=template&id=8831d2c2&scoped=true"
import script from "./CancelOrderModal.vue?vue&type=script&lang=ts"
export * from "./CancelOrderModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8831d2c2",
  null
  
)

export default component.exports